import { Box, Text } from '@chakra-ui/react';

const ElementErrorMessage = ({ form, index, qid }) => {
  if (
    form.errors.jobSeekerData &&
    form.errors.jobSeekerData[index] &&
    form.errors.jobSeekerData[index][qid]
  ) {
    return (
      <Box sx={{ margin: ['0', '0 0 0 16px'], textAlign: ['center', 'left'] }}>
        <Text variant="errorMessage">
          {form.errors.jobSeekerData[index][qid]}
        </Text>
      </Box>
    );
  } else {
    return null;
  }
};

export default ElementErrorMessage;
